
//const feapiurl = "http://api.schoone.de/frontend/";
const feapiurl = "https://api.evolvejobs.de/schoneboom/api/frontend/";
export default feapiurl;